import type { IconData } from '@stacksjs/iconify-core'

export const photographyFilePicture: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.425 6.09h-1.52V4.57h-1.52V3.04h-1.53V1.52h-1.52V0H3.045v32h25.91V7.62h-1.53Zm0 24.38H4.575V1.52h15.23v7.62h7.62Z\"/><path fill=\"currentColor\" d=\"M19.805 19.81v-1.53h-1.52v1.53h-9.14v-1.53h-1.53V7.62h-1.52v16.76h1.52v-3.05h16.77v3.05h1.52V10.66h-1.52v7.62h-1.53v1.53z\"/><path fill=\"currentColor\" d=\"M7.615 24.38h16.77v1.52H7.615Zm13.72-7.62h1.52v1.52h-1.52Zm-3.05-1.52h3.05v1.52h-3.05Zm-1.52 1.52h1.52v1.52h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm-3.04-1.53h3.04v1.53h-3.04Zm-1.53 1.53h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.52h-1.52Zm0-7.62h3.05v3.05h-3.05Zm-1.53-3.05h9.15v1.53h-9.15Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default photographyFilePicture
